// Added this page for CHG0073013
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import styles from './ProjectLinkageNotificationReport.module.css'
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import Truckloading from "../../components/CvLoader/Cvloader";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button, CustomTab } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeNumeric } from '../../utils/utils';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

function ProjectLinkageNotificationReport() {
const auth = useSelector((state) => state.auth); // useSelector
const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
const { showPopup } = usePopupManager();
  const ROW_HEIGHT = 38;
  const dispatch= useDispatch();
 
  let {
    userName,
    personNumber,
    companyCode,
    userRole,
    } = auth;
    let UserRoles = userRole;
    
  let requiredUsers= ["M", "DS", "S", "U","SA"];
  const userList = userRole.filter(role => requiredUsers.includes(role));
  const [tableData, setTableData] = useState([]);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [myState, setState] = React.useState(
    {
      checkFlag: false,
      UserRole: null,

    });
  const [loading, setLoading] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const HEIGHT = '';
  const FILENAME = 'Project_Linkage_Notification_Report';
  useEffect(() => {
    setViewDisplay(true);
  }, []);
 
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

    const handleUserRoleDetails= (e) => {
    setState((prevState) => ({ ...prevState, UserRole:e}));
    setViewDisplay(true);
    setRowsPerPage(10)
    setPage(0)
    setLoading(true);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}reports/ProjectNotificationReport`, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        // body: apiFormatedDataJson,
      })
      .then((response) => {
       
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])

          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        } 
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });

  }
    
useEffect(()=>{
    handleUserRoleDetails()
},[])

  const baseDefaultColumns = [
    {
      width: 80,
      title: 'Type',
      field: 'remark',
      enableSearch: true,
      enableFilter: true,
      headerStyle: {
        backgroundColor: 'yellow',
        fontWeight: 'bold',
      },
    },
    {
      width: 80,
      title: 'Project No',
      field: 'Project_No',
      enableSearch: true,
      enableFilter: true,
    },
    
    
    {
      width: 120,
      title: 'Project Desc',
      field: 'Project_Desc',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: 'Notification to Users(Date)',
      field: 'Notification_to_users',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: 'No of Mails',
      field: 'No_of_mails',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: 'No of Hrs Booked After Notification',
      field: 'No_Of_Hrs_Booked_after_Notification',
      enableSearch: true,
      enableFilter: true,
    },
  ];

  const renderReport = () => (
    <div
      className={styles.formGroup}

    >
      <div
        //  className={styles.customeTable}
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px",
        }}
      >
        <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >

        </Grid>
     <div className={styles.formGroup}>
   <div
      //  className={styles.customeTable}
      className={styles.col2} style={{
        width: "100%",
        height: "100%",
        marginTop: "10px",
      }}
    >
      <>
      
          <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME} />
    
         
    </>
    </div>
    </div>     
      </div>
    </div>)    
  return (
    <>
     <div className={styles.container} style={{ boxSizing: 'border-box' }}>
                    
                <div className={styles.processHeader}>
                <div className={styles.CustomTabClass} >
                        <CustomTab title="Report" withOutCount isSelected />
                    </div>
                    <div className={styles.processTopbar}>

                    <UserInfoPanel
                        userInfo={[{
                            "Name": "Siddesh Jadhav",
                            "SAP ID": 122355, "BC No": "122355",
                            "LOC": "Engineering and Research Center"
                        }]} />

                  </div>
                </div>

                <div className={clsx(styles.scrollContainer, styles.formContainer)}>     
          <CustomFormGroup header = 'Project Linkage Notification Report' body={renderReport()}  className = {clsx(styles.header)}/>
    
        {/* {renderReportTable()} */}
        {
          loading ? (
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                 <Truckloading />
              </div>):""
        }
      </div>
            </div>      
    </>
  )
}

export default ProjectLinkageNotificationReport